import React from "react";
import { connect } from "react-redux";

import { checkAccess, ids } from "../../../../helpers/rolAccess";
import { loadTabs } from "../../../Header/actions";

import Solicitudes from "./Solicitudes/view";
import Confirmacion from "./Confirmacion/view";
import EditarTrabajadores from "./Solicitudes/EditarTrabajadores";


class AgendaSel extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== "Agenda SEL ") {
      this.loadTabs();
    }

  }

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.solicitudSel, this.props.userAccessIds)) tabs.push({ text: "Solicitudes", contentId: 1, isActive: true });
    if (checkAccess(ids.confirmacionSolicitudSel, this.props.userAccessIds)) tabs.push({ text: "Confirmación", contentId: 2 });
    this.props.dispatch(loadTabs("Agenda SEL ", "", tabs, tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        return (
          <React.Fragment >
            <div></div>
          </React.Fragment>);
      }
      case 1: {
        return (
          <React.Fragment>
            {this.props.isEditTrabajadores ? <EditarTrabajadores /> : <Solicitudes />}
          </React.Fragment>
        );
      }
      case 2: {
        return (
          <React.Fragment>
            <Confirmacion />
          </React.Fragment>
        );
      }
      default:
        return <div />;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"agendaSel"}>{this.renderBody()}</div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  isEditTrabajadores: state.solicitudesAgendaSel.isEditTrabajadores,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgendaSel);
